<template>
    <div  class="form-page">
        <my-form readonly table>
            <my-form-item-group title="招标文件信息">
                <el-form-item label="招标文件名称" class="table-full-row">
                    {{form.zbfilename}}
                </el-form-item>  
                <!--
                <el-form-item label="招标包封形式">
                    <span v-if="form.issxf=='1'">双信封</span>
                </el-form-item>  -->
                <el-form-item label="相关标段" class="table-full-row">
                    <span v-for="item in formData.bdlist">
                        {{item.bdname}},
                    </span>
                </el-form-item>  
                <el-form-item
                    v-if="formData.xtdq&&type=='cq'"
                    label="是否变更预算或保证金"
                    class="table-full-row">
                        <el-table :data="dataList" border>
                            <el-table-column
                                prop="bdname"
                                label="标段名称"
                                min-width="160">
                            </el-table-column>
                            <el-table-column
                                label="是否变更预算"
                                min-width="160">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.izbgys=='0'">否</span>
                                        <div v-if="scope.row.izbgys=='1'">
                                            {{scope.row.bgys}}万元 人民币
                                        </div>
                                        
                                    </template>
                            </el-table-column>
                        </el-table>
                </el-form-item>
                <el-form-item label="开标时间">
                    {{form.kbtime}}
                </el-form-item>  
                <el-form-item label="文件递交截止时间">
                    {{form.tbwjdjjztime}}
                </el-form-item>  
                <el-form-item label="投标文件递交方法/平台地址">
                    {{form.tbwjdjff}}
                </el-form-item>  
                <el-form-item label="招标文件上传时间">
                    {{form.djtime}}
                </el-form-item>  
                <el-form-item label="投标保证金">
                    {{form.tbbzj}}{{form.jedwname}}{{form.bzname}}
                </el-form-item>  
                <el-form-item label="投标有效期(天)">
                    {{form.tbyxq}}
                </el-form-item>  
                <el-form-item label="开标方式">
                    {{form.kbfs}}
                </el-form-item>  
                <el-form-item label="资格审查方式">
                    {{form.zgscfs}}
                </el-form-item>  
                <el-form-item label="投标资格" class="table-full-row">
                    <span v-html="form.tbzg"></span>
                </el-form-item>
                <el-form-item label="质疑截止时间">
                    {{form.questionendday}}
                </el-form-item>
                <el-form-item label="受理质疑电话">
                    {{form.complaintsphone}}
                </el-form-item>
                <el-form-item 
                class="table-full-row"
                v-if="type=='cq'"
                label="是否推送河北省招标投标公共服务平台">
                    <span v-if="form.ishbpsp=='1'">是</span>
                    <span v-if="form.ishbpsp!='1'">否</span>
                </el-form-item>
                <template v-if="form.projectduration!=null">
                    <el-form-item label="供货时间">
                        {{form.projectduration}}
                    </el-form-item>  
                    <el-form-item label="开标地点">
                        {{form.bidopenaddr}}
                    </el-form-item> 
                    <el-form-item label="需要落实的政府采购政策" class="table-full-row">
                        {{form.implementpolicy}}
                    </el-form-item> 
                    <el-form-item label="简要技术要求（或采购项目性质）" class="table-full-row">
                        {{form.technicalrequirements}}
                    </el-form-item> 
                </template>
                <el-form-item label="澄清时间">
                    {{form.dycqtime}}
                </el-form-item>  
                <el-form-item label="澄清内容">
                    <span v-html="form.dycqcontent"></span>
                </el-form-item> 
                <template v-if="formData.bzname!='noperson'">
                    <el-form-item label="文件编制人" class="table-full-row">
                        {{formData.bzname}}
                    </el-form-item> 
                </template>
                <!--
                    <my-upload readonly :file-guid="form.fileguid"></my-upload>
                -->
                <el-form-item label="附件" class="table-full-row">
                    <el-table border :data="fileList">
                        <el-table-column label="文件名称" prop="filename">
                            <template slot-scope="scope">
                                <a 
                                    target="_blank"
                                    :href="`${getGetters('fileUrl')}/download/tender/hzb.do?rowguid=`+scope.row.rowguid+``">
                                        {{scope.row.filename}}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column label="上传时间" prop="fileuptime"></el-table-column>
                        <el-table-column label="上传人" prop="addusername"></el-table-column>
                    </el-table>
                </el-form-item> 

                <my-table :data="formData.listPfNode">
                    <el-table-column label="节点名称" prop="nodecaption"></el-table-column>
                    <el-table-column label="节点类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.nodetype=='YesOrNo'">符合性</span>
                            <span v-if="scope.row.nodetype=='Range'">范围</span> 
                            <span v-if="scope.row.nodetype=='BasePrice'">计算基准价</span> 
                            <span v-if="scope.row.nodetype=='Offer'">报价打分</span> 
                            <span v-if="scope.row.nodetype=='Candidate'">候选人</span> 
                            <span v-if="scope.row.nodetype=='Report'">评标报告</span>
                       		<span v-if="scope.row.nodetype=='EquipmentFilter'">设备型号评定步骤</span>
                       		<span v-if="scope.row.nodetype=='EquipmentYesOrNo'">设备类符合性评审步骤</span>
                       		<span v-if="scope.row.nodetype=='EquipmentRange'">设备类打分步骤</span>
                       		<span v-if="scope.row.nodetype=='EquipmentCheck'">关键设备推荐步骤</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="评分点" min-width="140">
                        <template slot-scope="scope">
                            <p class="el-button el-button--mini el-button--primary"
                                @click="DisDetailNode(scope.row.nodekey)"
                                v-if="scope.row.nodetype!='Offer'&&scope.row.nodetype!='BasePrice'">
                                详细评分点
                            </p>
                            <p v-if="scope.row.nodetype=='Range'">
                                {{scope.row.nodemaxmin}}
                            </p>
                            <p v-if="scope.row.nodetype=='Offer'||scope.row.nodetype=='BasePrice'">
                                <span v-html="scope.row.auditoption"></span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="PDF文件">
                        <template slot-scope="scope">
                            <p class="el-button el-button--mini el-button--primary"
                                @click="dispdf(formData.pdffile)"
                                v-if="scope.$index==0">
                                查看Pdf文件
                            </p>
                        </template>
                    </el-table-column>
                </my-table>
            </my-form-item-group>
            <my-form-item-group title="文件所带附件">
                <my-table :data="formData.flist">
                    <el-table-column label="文件夹" prop="filetype"></el-table-column>
                    <el-table-column label="文件名称">
                        <template slot-scope="scope">
                            <a :href="scope.row.href" target="_blank">
                                {{scope.row.filename}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column label="文件类型" prop="ext"></el-table-column>
                    <el-table-column label="文件大小" prop="size"></el-table-column>
                </my-table>
            </my-form-item-group>

            <el-form-item label="招标澄清备案表" class="table-full-row" v-if="formData.izsjjt">
                <span slot="label">
                    {{type==='cq' ? '招标澄清备案表' : '招标备案表'}}
                </span>
                <my-upload
                ref="myUpload"
                readonly
                :file-guid="form.babguid">
                </my-upload>
            </el-form-item>
        </my-form>

        <!-- 弹窗 -->
        <my-dialog 
            v-model="dialogVisible" 
            :width="dialogwidth"
            :title="dialogTitle">
                <component 
                    v-if="dialogVisible" 
                    :is="dialogComponent" 
                    :data="dialogData" 
                    @cancle="dialogClose">
                </component>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components:{
        pdfPreview: () => import('./dialog/pdfPreview'),
        pfNodeDetail: () => import('./dialog/pfnodedetail')
    },
    data() {
        return{
            form:{},
            formData:{},
            type:'',
            tableData:[],
            fileList:[],

            // dialog
            dialogComponent: '',
            dialogData: {},
            dialogTitle: '',
            dialogwidth:'893px',

            dataList:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 查看pdf文件
        dispdf(pdffile){
            this.dialogData = {
                pdffile:pdffile,
            };
            this.dialogTitle = 'pdf文件预览'
            this.dialogComponent = 'pdfPreview';
            this.dialogShow();
        },
        // 详细评分点
        DisDetailNode(nodekey){
            this.dialogData = {
                nodeid:nodekey,
                bdcode:this.formData.bdcode,
                filecontenttype:this.form.filecontenttype,
                type:this.type
            };
            this.dialogTitle = '详细评分点'
            this.dialogComponent = 'pfNodeDetail';
            this.dialogShow();
        },
        getList(fileguid){
            var that = this
            that.$get(`${that.getGetters('fileUrl')}/operate/getlist.json`, {
                fileguid: fileguid
            },(data, res) => {
                
                that.fileList = data
            })
        }

    },
    created() {
        var that = this
        that.type=that.getQuery('pageType')
     
    },
    mounted() {
        var that=this;
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.type+`/detail.json`, {
            id:that.getQuery('id'),
            procode:that.getQuery('procode'),
            forbidjump:that.getQuery('forbidjump'),
            zgys:that.getQuery('zgys'),
        },(data, res) => {
            that.form = data.model;
            that.formData = data
            that.getList(that.form.fileguid)
            that.dataList.push({ 
                bdname:data.model.bdname,
                bdcode:data.model.bdcode,
                izbgys:data.model.izbgys,
                bgys:data.model.bgys,
            })
        });
        
    }
}
</script>

<style scoped lang="scss">

</style>
